import { Content, DefaultPage } from '@shared/layout/DefaultPage'
import { BackArrowHeader } from '@widgets/BackArrowHeader'
import { Heading } from '@ui/Heading'
import { Card } from './card.ui'
import { useIonRouter } from '@ionic/react'
import { useQuery } from '@tanstack/react-query'
import { ExerciseProxy } from '@entities/exercise'
import { createSearchParams, generateFilters } from '@shared/helpers/generateSearchParams'
import SkeletonCard from 'react-loading-skeleton'

export const CheckTechniquePage = () => {
	const nav = useIonRouter()

	const goToAiCheck = (title: string) => {
		return nav.push(`/check_exercise?title=${title}`)
	}

	const { data, isLoading } = useQuery({
		queryKey: ['ai_exercises_page'],
		queryFn: () => {
			return ExerciseProxy.search(
				createSearchParams({
					filter: [
						generateFilters({
							operator: 'eq',
							property: 'is_ai_available',
							value: true,
						}),
					],
				})
			)
		},
	})

	return (
		<DefaultPage noPadding>
			<Content $padding className='app-bottom-nav-content'>
				<BackArrowHeader>
					<Heading>Проверка техники упражнений</Heading>
				</BackArrowHeader>
				{isLoading && (
					<div className={'mt-4 flex flex-col gap-y-3'}>
						<SkeletonCard height={94} className={'rounded-[15px]'}></SkeletonCard>
						<SkeletonCard height={94} className={'rounded-[15px]'}></SkeletonCard>
						<SkeletonCard height={94} className={'rounded-[15px]'}></SkeletonCard>
						<SkeletonCard height={94} className={'rounded-[15px]'}></SkeletonCard>
						<SkeletonCard height={94} className={'rounded-[15px]'}></SkeletonCard>
						<SkeletonCard height={94} className={'rounded-[15px]'}></SkeletonCard>
						<SkeletonCard height={94} className={'rounded-[15px]'}></SkeletonCard>
					</div>
				)}
				{/*<SearchField styles={{ marginTop: 23 }} />*/}
				{data && (
					<div className={'scroll-reveal-list mt-[15px] flex flex-col gap-y-3'}>
						{data.rows.map(exercise => {
							return (
								<Card
									key={exercise.id_exercise}
									img={exercise.media_files || undefined}
									title={exercise.name}
									muscle_group_codes={exercise.muscle_group_codes}
									onClick={goToAiCheck}
								/>
							)
						})}
					</div>
				)}
			</Content>
		</DefaultPage>
	)
}
